type Params = {
  studySlug: string;
  title?: string;
  contentType?: string;
  videoUid: string;
  selectedTags: string[];
  search?: string;
};

export const buildVideoNavigationPath = ({
  studySlug,
  title,
  contentType,
  videoUid,
  selectedTags,
  search,
}: Params): string => {
  const tags: string[] = [];

  if (title) tags.push(title);
  if (contentType) tags.push(contentType);
  tags.push(...selectedTags);

  const params = new URLSearchParams();

  if (tags.length > 0) {
    params.set("tags", tags.join(","));
  }

  const trimmedSearch = search?.trim();
  if (trimmedSearch) {
    params.set("search", trimmedSearch);
  }

  const queryString = params.toString();
  const suffix = queryString ? `?${queryString}` : "";

  if (title && contentType) {
    return `/${studySlug}/tabs/home/island/${encodeURIComponent(
      title
    )}/${encodeURIComponent(contentType)}/${videoUid}/default${suffix}`;
  }

  return `/${studySlug}/tabs/videos/${videoUid}/default${suffix}`;
};